import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Box,
  Backdrop,
  CircularProgress,
  Card,
  CardContent,
  Button,
  Typography
} from "@mui/material";
import {
  InfoDateUpdate,
  ContractSummary,
  NumberMaterials,
  VolumeDistributionCard
} from "./components";
import {
  VisibleContent
} from "../../components";
import agent from "../../agent/agent";
import moment from "moment";
import {showError, showSuccess} from "../../utils/notifications";
import { setContract, refreshContracts } from "../../store/ContractsStore";
import { changeCount } from "../../store/NotificationsStore";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastUpdate: moment(),
      isLoading: false,
      isBackdrop: false,
      isEmptyContract: false
    };
    this.timeOutUpdate = null;
  }

  getStatistics = async () => {
    clearTimeout(this.timeOutUpdate);
    await this.setState({ isLoading: true });

    await this.props.refreshContracts();
    const contract = this.props.contract;
    if (!contract) {
      await this.setState({
        isLoading: false,
        isEmptyContract: true,
      });
      return
    }

    this.setState({
      isLoading: false,
      lastUpdate: moment(),
      contract: contract
    });
    this.timeOutUpdate = setTimeout(async () => {
      await this.getStatistics();
    }, (5 * 60 * 1000));
  }
  exportStatistic = async (encoding) => {
    await this.setState({ isBackdrop: true });

    const {
      end_date,
      start_date
    } = this.props.contract?.contract_summary;
    const {
      contract_id
    } = this.props.contract?.available_contracts;
    const body = {
      datetime_end: end_date,
      type: "statistic_export",
      contract_id: contract_id,
      datetime_start: start_date,
      encoding: Number.parseFloat(encoding),
    };
    const res = await agent.post('/export/jobs', body)
      .then((res) => res.data).catch((err) => {
        return {error: err?.response?.data};
      });
    await this.setState({ isBackdrop: false });
    if (res?.error) {
      showError('Ошибка эксперта отчета', res?.error?.details)
      return
    }
    showSuccess('Экспорт отчета', 'Отчет поставлен в очередь, вы можете его найти в разделе "Результаты экспорта"', {paddingTop: '45px'})

    const currentExportCount = this.props.notifications?.counts?.export || 0;
    this.props.changeCount({ key: 'export', value: currentExportCount + 1 });
  }

  render() {
    const {
      lastUpdate,
      isLoading,
      isBackdrop,
      isEmptyContract
    } = this.state;
    const { contract, contractsLoading } = this.props;
    const contractId = contract?.available_contracts?.contract_id;
    const contractKey = contractId || 'no-contract';
    const noContract = !contract;

    if (contractsLoading) {
      return (
        <Box sx={{ mt: "20px" }}>
          <Card>
            <CardContent>
              <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", height: 120}}>
                <CircularProgress/>
              </Box>
            </CardContent>
          </Card>
        </Box>
      );
    }

    if (noContract || isEmptyContract) {
      return (
        <Box sx={{ mt: "20px" }}>
          <Card
            sx={{
              backgroundColor: "#d32f2f",
              borderRadius: "8px",
              boxShadow: "none",
              border: "none",
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "40px 20px",
                textAlign: "center",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#ffffff",
                  fontWeight: 600,
                  fontSize: "18px",
                  marginBottom: "16px",
                  lineHeight: 1.5,
                }}
              >
                У вас нет ни одного контракта
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#ffffff",
                  opacity: 0.9,
                  marginBottom: "24px",
                  fontSize: "14px",
                }}
              >
                Попробуйте обновить данные или обратитесь к администратору
              </Typography>
              <Button
                variant="contained"
                onClick={this.getStatistics}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#d32f2f",
                  height: "40px",
                  padding: "0 24px",
                  fontWeight: 600,
                  fontSize: "14px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                Обновить
              </Button>
            </CardContent>
          </Card>
        </Box>
      )
    }
    return (
      <>
        <VisibleContent visible={!isLoading && !isEmptyContract}>
          <Box key={contractKey} sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <InfoDateUpdate
              lastUpdate={lastUpdate}
              contractId={contractId}
              onUpdate={this.getStatistics}
              onExport={this.exportStatistic}
            />
            <NumberMaterials
              statistic={contract}
            />
            <ContractSummary
              statistic={contract}
            />
            <VolumeDistributionCard
              statistic={contract}
            />
          </Box>
        </VisibleContent>
        <VisibleContent visible={isLoading}>
          <Card>
            <CardContent>
              <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", height: 120}}>
                <CircularProgress/>
              </Box>
            </CardContent>
          </Card>
        </VisibleContent>
        <Backdrop open={isBackdrop}>
          <CircularProgress/>
        </Backdrop>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  contract: state.contracts?.contract || null,
  contractsLoading: state.contracts?.isLoading || false,
  notifications: state.notifications || { counts: {} },
});
const mapDispatchToProps = {
  setContract,
  refreshContracts,
  changeCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home)
